module.exports = __webpack_public_path__ + "static/completa-album_v02-a3f2fcb51eb034fc6e12b5ddbac5ee15.png";